import React from 'react'

export default function useSubmitting(initial = false) {
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(initial);
  const submittingRef = React.useRef<boolean>(initial);

  React.useEffect(() => {
    submittingRef.current = isSubmitting;
  }, [isSubmitting]);

  const start = () => setIsSubmitting(true);
  const stop = () => setIsSubmitting(false);

  // wrap an async function so it won't run if already submitting
  const wrap = <T extends any[]>(fn: (...args: T) => Promise<any>) => {
    return async (...args: T) => {
      if (submittingRef.current) return;
      start();
      try {
        return await fn(...args);
      } finally {
        stop();
      }
    };
  };

  return { isSubmitting, start, stop, wrap } as const;
}
